import { getService } from "../../../shared/react/utils";

export const lotSetup = () => {
  const $state = getService("$state");

  return $state.current.name === "edit-property-advanced-rates-lot-setup";
};
